export default "__VITE_ASSET__WDE1SaOF__"